import { useQuery } from "@tanstack/react-query";
import { SecurityAppInvestigationsSummary } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchAvailability = () => SecurityAppInvestigationsSummary.reportAvailability().then((response) => {
  var _a;
  return {
    available: response.available,
    message: (_a = response.message) != null ? _a : void 0
  };
});
const useInvestigationReportAvailability = (enabled) => {
  const { data, isLoading } = useQuery({
    queryKey: ["investigation-ai-report", "availability"],
    queryFn: () => defaultOnError(
      fetchAvailability(),
      i18n.t("notifications.check_ai_report_availability_failed", { ns: "enterprise_security_investigations" }),
      i18n.t("notifications.could_not_check_ai_report_availability", { ns: "enterprise_security_investigations" })
    ),
    enabled
  });
  return { data: data != null ? data : { available: false, message: void 0 }, isLoading: enabled && isLoading };
};
export default useInvestigationReportAvailability;
